
const Storage = {
    getCookie: function (cname: string) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },

    setCookie: function (cname: string, cvalue: string, exhours: number) {
        // const d = new Date();
        // d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
        // let expires = "expires=" + d.toUTCString();
        // document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      sessionStorage.setItem(cname, cvalue)
    },


    setAccessToken: function (val: string) {
        return sessionStorage.setItem("ctoken", val)
    },

    getAccessToken: function () {
        return sessionStorage.getItem("ctoken")
    },

    resetAccessToken: function () {
        return sessionStorage.removeItem("ctoken")
    },

    getRefreshToken: function () {
        return sessionStorage.getItem("refresh")
    },

    setRefreshToken: function (val: string) {
        return sessionStorage.setItem("refresh", val)
    },

    resetRefreshToken: function () {
        return sessionStorage.removeItem("refresh")
    },
};

export default Storage;
